import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DcAlertModule } from '@datachain/ui-sdk/components/alert';
import { DcButtonModule } from '@datachain/ui-sdk/components/app-button';
import { DcOverlayBadgeModule } from '@datachain/ui-sdk/components/app-overlay-badge';
import { DcPageModule } from '@datachain/ui-sdk/components/app-page';
import { DcPanelModule } from '@datachain/ui-sdk/components/app-panel';
import { DcPopoverModule } from '@datachain/ui-sdk/components/app-popover';
import { DcAvatarModule } from '@datachain/ui-sdk/components/avatar';
import { DcBreadcrumbModule } from '@datachain/ui-sdk/components/breadcrumb';
import { DcNavigateDirectiveModule } from '@datachain/ui-sdk/directives';
import {
	DcArrayPipeModule,
	DcTruncatePipeModule,
} from '@datachain/ui-sdk/pipes';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DxDataGridModule } from 'devextreme-angular';
import { NgxColorsModule } from 'ngx-colors';

import { UiModule } from '../ui/ui.module';
import { ConfigPopupComponent } from './components/config-popup/config-popup.component';
import { GroupingTagActionConfirmPopupComponent } from './components/grouping-tag-action-confirm-popup/grouping-tag-action-confirm-popup.component';
import { GroupingTagListWrapperComponent } from './components/grouping-tag-list-wrapper/grouping-tag-list-wrapper.component';
import { GroupingTagListComponent } from './components/grouping-tag-list/grouping-tag-list.component';
import { GroupingTagAdapter } from './grouping-tag.adapter';
import {
	GroupingTagEffects,
	GroupingTagFeatureKey,
	groupingTagReducers,
	GroupingTagSelector,
} from './store';

@NgModule({
	declarations: [
		GroupingTagListWrapperComponent,
		GroupingTagListComponent,
		ConfigPopupComponent,
		GroupingTagActionConfirmPopupComponent,
	],
	imports: [
		CommonModule,
		StoreModule.forFeature(GroupingTagFeatureKey, groupingTagReducers),
		EffectsModule.forFeature([GroupingTagEffects]),
		UiModule,
		DcPanelModule,
		MatIconModule,
		DxDataGridModule,
		DcArrayPipeModule,
		DcAvatarModule,
		MatTooltipModule,
		DcNavigateDirectiveModule,
		MatButtonModule,
		MatMenuModule,
		DcButtonModule,
		DcPageModule,
		DcBreadcrumbModule,
		FormsModule,
		NgxColorsModule,
		DcAlertModule,
		MatCheckboxModule,
		DcTruncatePipeModule,
		DcOverlayBadgeModule,
		DcPopoverModule,
		MatProgressSpinnerModule,
	],
	providers: [GroupingTagAdapter, GroupingTagSelector],
})
export class GroupingTagModule {
	public constructor(private readonly injector: Injector) {
		const groupingTagPageCmpElement = createCustomElement(
			GroupingTagListWrapperComponent,
			{
				injector,
			}
		);
		customElements.define(
			'app-grouping-tag-list-wrapper',
			groupingTagPageCmpElement
		);
	}
}
